import * as React from 'react'
import { Button, withStyles } from '@material-ui/core'
import { useState } from 'react'
import { compose } from 'underscore'
import { connect } from 'react-redux'

import { ReduxState } from 'src/store/reducers'
import { getTranslation, Translate } from 'src/translation'
import history from 'src/history'

import { styles } from './GetSupportDialog.styles'
import CreateSupportTask from 'src/components/routes/chat/components/CreateSupportTask'

type Props = {
  classes: {
    supportButton: string
  }
  translate: Translate
}
const GetSupportDialog = (props: Props) => {
  const { classes, translate } = props
  const [isOpen, setIsOpen] = useState(false)

  const setupDefaultTaskFilters = () => {
    const localfilters = localStorage.getItem('tasksFilters')

    if (!localfilters) {
      return
    }

    const localFiltersParsed = JSON.parse(localfilters)
    const localFiltersTaskSubTypes = localFiltersParsed?.taskSubType
    const localFiltersTaskStatus = localFiltersParsed?.status

    if (!localFiltersTaskSubTypes.includes('support-ticket')) {
      localFiltersTaskSubTypes.push('support-ticket')
    }
    if (!localFiltersTaskStatus.includes('notStarted')) {
      localFiltersTaskStatus.push('notStarted')
    }

    const updatedFilters = {
      ...localFiltersParsed,
      taskSubType: localFiltersTaskSubTypes,
      status: localFiltersTaskStatus
    }

    localStorage.setItem('tasksFilters', JSON.stringify(updatedFilters))
  }

  return (
    <>
      <Button
        id="get-assistance-button"
        className={`ml-4 ${classes.supportButton}`}
        onClick={() => {
          setIsOpen(true)
        }}
      >
        {translate('get-assistance')}
      </Button>

      {isOpen && (
        <CreateSupportTask
          callback={(chatId?: string) => {
            setupDefaultTaskFilters()
            history.push(`/tasks?selectedTaskChatId=${chatId}&&isAssistedSearch=true`)
          }}
          onClose={() => {
            setIsOpen(false)
          }}
        />
      )}
    </>
  )
}

function mapStateToProps(state: ReduxState, ownProps) {
  return {
    ...ownProps,
    tubeColor: state.auth.tube.color,
    translate: getTranslation(state.translation.lang)
  }
}

export default compose(withStyles(styles, { withTheme: true }), connect(mapStateToProps))(GetSupportDialog)
